module.exports = __webpack_public_path__ + "media/Agawan Base Moment.906c4af1.mp3";